import { createSelector } from '@reduxjs/toolkit';
import { State } from './types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.ApiVersion;

export const statusSelector = createSelector(rootSelector, (apiVersion) => apiVersion.status);

export const errorSelector = createSelector(rootSelector, (apiVersion) => apiVersion.error);

export const apiVersionSelector = createSelector(rootSelector, (apiVersion) => apiVersion.data);

export default {
  statusSelector,
  errorSelector,
  apiVersionSelector,
};
